<section class="specimens-and-samples-wrapper" *ngIf="loaded; else Loader">
  <section class="specimens-and-samples-header" *ngIf="newItemOptions && newItemOptions.length > 0 && (isActiveStep('testInfoReview')|| isActiveStep('pipelineFailed'))">
    <section class="specimens-and-samples-header-right-side">
      <gen-options-button class="options-button"
                          [buttonIconClass]="'icon__plus'"
                          [buttonText]="createButtonText"
                          [options]="newItemOptions">
      </gen-options-button>
    </section>
  </section>
  <section class="samples-forms-container">
    <form name="specimensAndSamplesForm" class="specimens-and-samples-form Marginbox__b-medium  profile-content" autocomplete="off">
      <div class="Flexbox Flexbox__direction-rows results-pane" style="flex: 1 0 auto;">
        <gen-sample-viewer
          (updatedOrder)="emitUpdate($event)"
          [samples]="currentOrder.specimen"
          [sampletype]="testConfiguration.specimenConfig[0].specimenType"
          [showaddbutton]="testConfiguration.allowAddSpecimen"
          [samplesConfig]="testConfiguration.specimenConfig"
          [markAsPrimaryEnabled]=markAsPrimaryEnabled
          [proceedToAnaliseStarted]="!(isActiveStep('testInfoReview') || isActiveStep('pipelineFailed'))"
          [disabledForced]="!this.isAssignee"
          [primaryid]="currentOrder.primaryTumor"
          [editMode]="true"
          [overrides]="formsOverrides"
          [allowedit]="isEditableField">
        </gen-sample-viewer>
      </div>
      <div class="Flexbox Flexbox__box-direction-column-reverse results-pane  Marginbox__r-medium Spacebox__t-medium "
           *ngIf="isActiveStep('testInfoReview') || isActiveStep('pipelineFailed')"
      >
        <input type="button" class="btn btn-primary"
               (click)="proceedToAnalysis()"
               [value]="proceedToAnalysisButtonText"
               [disabled]="proceedToAnalysisDisabled"
        />
      </div>
    </form>
  </section>
</section>

<ng-template #Loader>
  <gen-overlay-loader [showOverlay]="false"></gen-overlay-loader>
</ng-template>
